'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d = require('d3');

var d3 = _interopRequireWildcard(_d);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _generalUtils = require('../generalUtils');

var _generalUtils2 = _interopRequireDefault(_generalUtils);

var _utahCharities = require('../utahCharities.csv');

var _utahCharities2 = _interopRequireDefault(_utahCharities);

var _template = require('./template.html');

var _template2 = _interopRequireDefault(_template);

require('./style.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function updatePlayOrBet() {
  if (d3.select('#willPlay').property('checked')) {
    d3.select('#signupForm').style('display', null);
    d3.select('#betForm').style('display', 'none');
  } else {
    d3.selectAll('#signupForm').style('display', 'none');
    d3.select('#betForm').style('display', null);
  }
}

function populateCharityList() {
  d3.csv(_utahCharities2.default, function (results) {
    var options = d3.select('#charityList').selectAll('option').data(results);
    options = options.enter().append('option').merge(options);
    options.text(function (d) {
      return d['CHARITY NAME'];
    });
  });
}

function validateSignupForm() {
  var name = d3.select('#name').property('value');
  var charity = d3.select('#charity').property('value');
  if (window.GLOBALS.DATA.Players.contents.filter(function (d) {
    return d['Player Name'] === name;
  }).length > 0) {
    d3.select('#name').classed('error', true);
    _generalUtils2.default.displayNotification('Sorry, someone already signed up with that name');
    return Promise.reject();
  }
  if (name && charity) {
    return Promise.resolve();
  } else {
    if (!name) {
      d3.select('#name').classed('error', true);
    }
    if (!charity) {
      d3.select('#charity').classed('error', true);
    }
    return Promise.reject();
  }
}

function validateBetForm() {
  if (d3.select('#bet').property('value') !== 'Choose a Player') {
    return Promise.resolve();
  } else {
    d3.select('#bet').classed('error', true);
    return Promise.reject();
  }
}

function setup() {
  (0, _jquery2.default)('#signupTab').html(_template2.default);

  // Charity list
  populateCharityList();

  // Radio buttons
  d3.selectAll('#willPlay, #willBet').on('change', function () {
    updatePlayOrBet();
  });
  updatePlayOrBet();

  // Submission buttons
  d3.select('#signupButton').on('click', function () {
    _generalUtils2.default.handleSubmission(validateSignupForm, 'Players', this.parentElement.parentElement);
  });
  d3.select('#betButton').on('click', function () {
    _generalUtils2.default.handleSubmission(validateBetForm, 'Bets', this.parentElement.parentElement);
  });
}

function render() {
  // People select menu
  _generalUtils2.default.populatePlayerLists('#bet');

  // Update sign up status
  if (window.GLOBALS.NOW < window.GLOBALS.SIGNUP_DEADLINE) {
    (0, _jquery2.default)('.cantSignup').hide();
    (0, _jquery2.default)('#signupDeadline').text(window.GLOBALS.SIGNUP_DEADLINE.toLocaleString());
  } else {
    (0, _jquery2.default)('.canSignup').hide();
    d3.select('#willPlay').property('disabled', true);
    d3.select('#willBet').property('checked', true);
    updatePlayOrBet();
  }
}

exports.default = {
  setup: setup,
  render: render
};


//////////////////
// WEBPACK FOOTER
// ./signupTab/signupTab.js
// module id = 9
// module chunks = 0